import React, { memo } from 'react'
import { Heading, Flex, Box, Divider } from 'pcln-design-system'
import { CheckboxCategoryGroup } from '@pcln/filter'
import { applySetiToFilters } from '../helpers'
import { useAirportsFilters } from './hooks/useAirportsFilters'
import { SelectAllorNone } from '../../AllOrNone/SelectAllorNone'

/**
 * Airports Filters Component Using Hooks
 * @returns <AirportsFilters />
 */

function AirportsFilters({ changeHandler }) {
  const {
    originFilter,
    destinationFilter,
    handleOnlyClick,
    onSelectAllClick,
    onSelectNoneClick,
    isSelectAllDisabled,
    isSelectNoneDisabled,
  } = useAirportsFilters({ changeHandler })

  return (
    <Box pb='24px'>
      <Flex mb={2} alignItems='center' justifyContent='space-between'>
        <Heading fontSize={2} bold>
          Airports
        </Heading>
      </Flex>
      <Divider mb={2} mt={0} />
      <SelectAllorNone
        isSelectNoneDisabled={isSelectNoneDisabled}
        isSelectAllDisabled={isSelectAllDisabled}
        onSelectAllClick={onSelectAllClick}
        onSelectNoneClick={onSelectNoneClick}
      />

      <Box pb={3} pt={2}>
        <Heading.h3 fontSize={1} mb={1}>
          Departing From
        </Heading.h3>
        <CheckboxCategoryGroup
          filters={applySetiToFilters({
            filters: originFilter.filters,
            handleOnlyFilter: handleOnlyClick('origin'),
            noTranslate: true,
          })}
          handleChange={originFilter.handleChange}
          className='flight-airport-origin-filters'
          wrapLabel={false}
          shouldPadConsistently
        />
      </Box>

      <Box>
        <Heading.h3 fontSize={1} mb={1}>
          Traveling To
        </Heading.h3>
        <CheckboxCategoryGroup
          filters={applySetiToFilters({
            filters: destinationFilter.filters,
            handleOnlyFilter: handleOnlyClick('dest'),
            noTranslate: true,
          })}
          handleChange={destinationFilter.handleChange}
          className='flight-airport-destination-filters'
          wrapLabel={false}
          shouldPadConsistently
        />
      </Box>
    </Box>
  )
}

export default memo(AirportsFilters)
